/**
 * @fileoverview Semantic markup mode
 * @module screen-view-v2/context/SemanticMarkupContext
 *
 * `'article'` switches FlexibleLayout Text sections from `div` to real heading
 * and paragraph elements (first titled Text section → h1, later titles → h2,
 * subtitles → p) so zero-JS crawlers read a document outline from the SSR HTML.
 * Provided ONLY by the web-shell engine for `metadata.kind === 'article'`
 * documents — on the SSR render AND the hydrating client render, so the markup
 * never mismatches. Default `null` keeps every other surface (funnels, editor
 * canvas, previews) byte-identical.
 */

import React from 'react';

export type SemanticMarkupMode = 'article';

export const SemanticMarkupContext = React.createContext<SemanticMarkupMode | null>(null);

SemanticMarkupContext.displayName = 'SemanticMarkupContext';
